import { mapActions } from 'vuex';

export default {
	components: {},
	props: {
		show: {
			type: Boolean
		}
	},
	data() {
		return {
			dialogVisible: false,
			ruleForm: {
				code: '',
				name: '',
				email: '',
				password: '',
			},
			rules: {
				code: [
					{
						required: true,
						message: "Це поле є обов'язковим",
					},
					{
						min: 8,
						max: 12,
						message: 'Довжина цього поля повина бути від 8 до 12 символів',
						trigger: 'blur',
					},
				],
				contractNumber: [
					{
						required: true,
						message: "Номер договору є обов'язковим",
					},
				],
				name: [{ required: true, message: "Назва контрагенту є обов'язковою" }],
				email: [{ required: true, message: 'Електрона пошта є обовязковою' }],
				password: [
					{
						required: true,
						min: 6,
						message: 'Довжина паролю повина бути від 3 до 8 символів',
						trigger: 'blur',
					},
				],
			},
		}
	},
	watch: {
		show(val) {
			this.dialogVisible = val;
		}
	},
	methods: {
		...mapActions(['register', 'addUser']),
		submitForm() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					this.register(this.ruleForm)
						.then((resp) => {
							this.$emit('update:show', false);
							console.log(resp.data);
							this.$notify.success({
								title: 'Успіх',
								message: 'Користувача успішно додано!',
							});
							this.addUser(resp.data.user);
						})
						.catch((error) => {
							this.$notify.error({
								title: 'Error',
								message: error.response.data,
							});
						});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
	},
}